"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionText = exports.Question = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _types = require("../../../types");
var _utils = require("../../../utils");
var _components = require("../../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Question = function Question(props) {
  var question = props.question,
    answer = props.answer,
    label = props.label,
    QuestionRenderer = props.QuestionRenderer;
  var htmlId = (0, _utils.useUniqueHtmlId)();
  if (QuestionRenderer) {
    var _Question = QuestionRenderer((0, _lodash.omit)(props, 'QuestionRenderer'));
    if (_Question) {
      return _Question;
    }
  }
  switch (question.type) {
    case _types.SurveyQuestionTypesEnum.ALLERGIES:
      {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "--tag-allergies-question flex flex-col gap-y-[8px]"
        }, /*#__PURE__*/_react.default.createElement(QuestionText, null, question.text), /*#__PURE__*/_react.default.createElement("ol", {
          className: "flex flex-col gap-y-[8px]"
        }, answer === null || answer === void 0 ? void 0 : answer.answer.map(function (answer) {
          var parsedAnswer = JSON.parse(answer);
          return /*#__PURE__*/_react.default.createElement("li", {
            key: answer
          }, parsedAnswer.allergen, ", reaction: ", parsedAnswer.reaction);
        })));
      }
    case _types.SurveyQuestionTypesEnum.SELECT:
      {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "--tag-radio-question flex flex-col gap-y-[8px]"
        }, /*#__PURE__*/_react.default.createElement(QuestionText, null, question.name === _utils.DETOX_RECOMMENDED_QUESTION_NAME ? '' : label || question.text), /*#__PURE__*/_react.default.createElement("p", {
          className: "tw-body-light"
        }, answer === null || answer === void 0 ? void 0 : answer.answer[0]), question.note && /*#__PURE__*/_react.default.createElement(QuestioNote, null, question.note));
      }
    case _types.SurveyQuestionTypesEnum.OPEN:
      {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "--tag-text-area-question flex flex-col gap-y-[8px]"
        }, /*#__PURE__*/_react.default.createElement(QuestionText, {
          htmlFor: htmlId
        }, label || question.text), /*#__PURE__*/_react.default.createElement(_components.TextInput, {
          multiline: true,
          disabled: true,
          id: htmlId,
          value: answer === null || answer === void 0 ? void 0 : answer.answer[0]
        }), question.note && /*#__PURE__*/_react.default.createElement(QuestioNote, null, question.note));
      }
    case _types.SurveyQuestionTypesEnum.MULTISELECT:
      {
        var _answer$answerIds;
        var fieldName = question.id;
        var inputValue = answer === null || answer === void 0 ? void 0 : (_answer$answerIds = answer.answerIds) === null || _answer$answerIds === void 0 ? void 0 : _answer$answerIds.map(String);
        var options = question.answers.map(function (_ref) {
          var text = _ref.text,
            id = _ref.id;
          return {
            label: text,
            value: String(id)
          };
        })
        // Don't show answers that are not selected if there are a lot of answer options
        .filter(function (_ref2) {
          var value = _ref2.value;
          return question.answers.length > 5 ? inputValue === null || inputValue === void 0 ? void 0 : inputValue.includes(value) : true;
        });
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "--tag-checkbox-question flex flex-col gap-y-[8px]"
        }, /*#__PURE__*/_react.default.createElement(QuestionText, null, label || question.text), /*#__PURE__*/_react.default.createElement(_components.Checkbox.Group, {
          name: String(fieldName),
          disabled: true,
          value: inputValue
        }, options.map(function (option) {
          return /*#__PURE__*/_react.default.createElement(_components.Checkbox, {
            key: option.label,
            value: option.value
          }, option.label);
        })), question.note && /*#__PURE__*/_react.default.createElement(QuestioNote, null, question.note));
      }
    case _types.SurveyQuestionTypesEnum.SELECT_DROPDOWN:
      {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "--tag-select-dropdown-question flex flex-col gap-y-[8px]"
        }, /*#__PURE__*/_react.default.createElement(QuestionText, null, label || question.text), /*#__PURE__*/_react.default.createElement(_components.SelectInput, {
          disabled: true,
          value: answer === null || answer === void 0 ? void 0 : answer.answerIds[0],
          inputWrapperStyles: "!border-[1px] !border-solid !border-grey-25 rounded-[4px] !pt-[10px]",
          inputStyles: "px-[10px]",
          iconStyles: "right-[10px]"
        }, question.answers.map(function (_ref3) {
          var id = _ref3.id,
            text = _ref3.text;
          return /*#__PURE__*/_react.default.createElement(_components.SelectInput.Option, {
            key: id,
            value: id
          }, text);
        })), question.note && /*#__PURE__*/_react.default.createElement(QuestioNote, null, question.note));
      }
    default:
      return null;
  }
};
exports.Question = Question;
var QuestionText = function QuestionText(_ref4) {
  var htmlFor = _ref4.htmlFor,
    children = _ref4.children;
  return htmlFor ? /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: htmlFor,
    className: "block tw-label-medium"
  }, children) : /*#__PURE__*/_react.default.createElement("p", {
    className: "block tw-label-medium"
  }, children);
};
exports.QuestionText = QuestionText;
var QuestioNote = function QuestioNote(_ref5) {
  var children = _ref5.children;
  return (
    /*#__PURE__*/
    // Some notes contain HTML tags, so we need to render them as HTML
    _react.default.createElement("div", {
      className: "--tag-extra-question-note",
      dangerouslySetInnerHTML: {
        __html: children
      }
    })
  );
};